"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValueModel = void 0;
const mobx_1 = require("mobx");
const Model_1 = require("@zajno/common/models/Model");
class ValueModel extends Model_1.Model {
    constructor(v = null, useRefObservable = true) {
        super(v);
        (0, mobx_1.makeObservable)(this, {
            _value: useRefObservable ? mobx_1.observable.ref : mobx_1.observable,
            setValue: mobx_1.action,
        });
    }
}
exports.ValueModel = ValueModel;
//# sourceMappingURL=ValueModel.js.map